module.exports = __webpack_public_path__ + "6d82a7375d1a8ee53657790b692e9c06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room4/administrating_4608.jpg
// module id = 898
// module chunks = 0